const STATIC_NAMESPACE_ID = 'b6fec9b4-118d-4064-b1b5-bf0df5b75201';

export { STATIC_NAMESPACE_ID };
